import { GhostMark } from './GhostMark'
import { Badge } from './ui'
import { CRED_META, TRUST_TIERS } from '../lib/constants'
import type { CredentialState, TrustTier } from '../lib/types'

// ─────────────────────────────────────────────────────────────────────────
// Verification display primitives. These encode the product rule that a
// credential is shown as a positive, attributable signal — the Ghost mark
// tinted to the credential state, plus an honest label.
// ─────────────────────────────────────────────────────────────────────────

/** Compact tier badge: the tinted Ghost + "Tier N · Name". */
export function TierBadge({
  tier,
  state,
  size = 22,
  showName = true,
}: {
  tier: TrustTier
  state: CredentialState
  size?: number
  showName?: boolean
}) {
  const meta = TRUST_TIERS[tier]
  const cred = CRED_META[state]
  return (
    <span className="tier-badge" title={`${meta.name} — ${meta.blurb}`}>
      <GhostMark size={size} tint={state} breathing={cred.live} />
      <span style={{ color: cred.color }}>
        Tier {tier}
        {showName ? ` · ${meta.name}` : ''}
      </span>
    </span>
  )
}

/** A pill describing the credential state (e.g. "Live verified"). */
export function CredentialBadge({ state }: { state: CredentialState }) {
  const cred = CRED_META[state]
  return (
    <Badge color={cred.color} bg={cred.bg} dot live={cred.live}>
      {cred.label}
    </Badge>
  )
}
